import { handleAvailable, handleRequest, handleUnavailable } from '../reducerHandlers'
import { CONTACTS_AVAILABLE, CONTACTS_REQUEST, CONTACTS_UNAVAILABLE, SNACK_SET } from './constants';
import { createReducer } from './utils';

const defaultState = {
  contacts: [],
  loadingContacts: false,
  postContactResponse: {},
  loadingPostContact: false,
  contactRoles: [],
  loadingContactRoles: false,
  regions: [],
  loadingRegions: false,
  notificationFeatures: [],
  loadingNotificationFeatures: false,
  patchContactResponse: {},
  loadingPatchContact: false,
  deleteContactResponse: {},
  loadingDeleteContact: false,
}

// Reducer

export const reducer = createReducer(defaultState, {
  [CONTACTS_REQUEST]: handleRequest,
  [CONTACTS_AVAILABLE]: handleAvailable,
  [CONTACTS_UNAVAILABLE]: handleUnavailable,
});

// Actions

export function getContacts(includeCWSUsers = false, includeCWSProducts = false, includeTaskManagerUsers = false, includeTaskManagerRoles = false) {
  return async (dispatch, _, { services: { dataSource } }) => {
    const keyState = 'contacts'
    const loadingName = 'loadingContacts'
    dispatch({ type: CONTACTS_REQUEST, payload: { loadingName: loadingName } });
    try {
      const response = await dataSource.getContacts(includeCWSUsers, includeCWSProducts, includeTaskManagerUsers, includeTaskManagerRoles);
      dispatch({
        type: CONTACTS_AVAILABLE,
        payload: { keyState: keyState, data: response, loadingName: loadingName },
      });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CONTACTS_UNAVAILABLE,
        payload: { keyState: keyState, loadingName: loadingName, defaultState: [] },
      });
      const snack = {
        open: true,
        message: "There was an error getting the contacts information.",
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function postContact(body) {
  return async (dispatch, _, { services: { dataSource } }) => {
    const keyState = 'postContactResponse'
    const loadingName = 'loadingPostContact'
    dispatch({ type: CONTACTS_REQUEST, payload: { loadingName: loadingName } });
    try {
      const response = await dataSource.postContact(body);
      dispatch({
        type: CONTACTS_AVAILABLE,
        payload: { keyState: keyState, data: response, loadingName: loadingName },
      });
      const snack = {
        open: true,
        message: "Contact created successfully.",
        severity: 'success',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CONTACTS_UNAVAILABLE,
        payload: { keyState: keyState, loadingName: loadingName, defaultState: {} },
      });
      const snack = {
        open: true,
        message: "There was an error creating the contact.",
        severity: 'error'
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function patchContact(body) {
  return async (dispatch, _, { services: { dataSource } }) => {
    const keyState = 'patchContactResponse'
    const loadingName = 'loadingPatchContact'
    dispatch({ type: CONTACTS_REQUEST, payload: { loadingName: loadingName } });
    try {
      const response = await dataSource.patchContact(body);
      dispatch({
        type: CONTACTS_AVAILABLE,
        payload: { keyState: keyState, data: response, loadingName: loadingName },
      });
      const snack = {
        open: true,
        message: "Contact updated successfully.",
        severity: 'success',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CONTACTS_UNAVAILABLE,
        payload: { keyState: keyState, loadingName: loadingName, defaultState: {} },
      });
      const snack = {
        open: true,
        message: "There was an error updating the contact.",
        severity: 'error'
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function deleteContact(body) {
  return async (dispatch, _, { services: { dataSource } }) => {
    const keyState = 'deleteContactResponse'
    const loadingName = 'loadingDeleteContact'
    dispatch({ type: CONTACTS_REQUEST, payload: { loadingName: loadingName } });
    try {
      const response = await dataSource.deleteContact(body);
      dispatch({
        type: CONTACTS_AVAILABLE,
        payload: { keyState: keyState, data: response, loadingName: loadingName },
      });
      const snack = {
        open: true,
        message: "Contact deleted successfully.",
        severity: 'success',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CONTACTS_UNAVAILABLE,
        payload: { keyState: keyState, loadingName: loadingName, defaultState: {} },
      });
      const snack = {
        open: true,
        message: "There was an error deleting the contact.",
        severity: 'error'
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function getContactNotificationFeatures() {
  return async (dispatch, _, { services: { dataSource } }) => {
    const keyState = 'notificationFeatures'
    const loadingName = 'loadingNotificationFeatures'
    dispatch({ type: CONTACTS_REQUEST, payload: { loadingName: loadingName } });
    try {
      const response = await dataSource.getContactNotificationFeatures();
      dispatch({
        type: CONTACTS_AVAILABLE,
        payload: { keyState: keyState, data: response, loadingName: loadingName },
      });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CONTACTS_UNAVAILABLE,
        payload: { keyState: keyState, loadingName: loadingName, defaultState: [] },
      });
      const snack = {
        open: true,
        message: "There was an error getting the notification features.",
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function getContactRoles() {
  return async (dispatch, _, { services: { dataSource } }) => {
    const keyState = 'contactRoles'
    const loadingName = 'loadingContactRoles'
    dispatch({ type: CONTACTS_REQUEST, payload: { loadingName: loadingName } });
    try {
      const response = await dataSource.getContactRoles();
      dispatch({
        type: CONTACTS_AVAILABLE,
        payload: { keyState: keyState, data: response, loadingName: loadingName },
      });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CONTACTS_UNAVAILABLE,
        payload: { keyState: keyState, loadingName: loadingName, defaultState: [] },
      });
      const snack = {
        open: true,
        message: "There was an error getting the contact roles.",
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function getRegions() {
  return async (dispatch, _, { services: { dataSource } }) => {
    const keyState = 'regions'
    const loadingName = 'loadingRegions'
    dispatch({ type: CONTACTS_REQUEST, payload: { loadingName: loadingName } });
    try {
      const response = await dataSource.getRegions();
      dispatch({
        type: CONTACTS_AVAILABLE,
        payload: { keyState: keyState, data: response, loadingName: loadingName },
      });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CONTACTS_UNAVAILABLE,
        payload: { keyState: keyState, loadingName: loadingName, defaultState: [] },
      });
      const snack = {
        open: true,
        message: "There was an error getting the regions.",
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}